<template>
  <van-dialog
    v-if="show && levelCode"
    v-model="show"
    class="share-modal-box"
    :class="displayLayout"
    overlayClass="share-modal-overlay"
    :show-confirm-button="false"
    :close-on-click-overlay="false"
  >
    <!-- 关闭按钮 -->
    <MBIcon
      name="c-close-grey"
      defaultClass="colour"
      :size="displayLayout === 'desktop-layout' ? 36 : 60"
      @click="close"
    />
    <div class="share-body">
      <div class="flex-col-center">
        <!-- 分享的图片 -->
        <ShareImage :levelCode="levelCode" @cancel="close" />
        <!-- 保存提示 -->
        <p class="save-tip" v-show="!isApp">
          {{ $t('memberShare.clickSave') }}
        </p>
        <div class="dividing-line"></div>
        <!-- 分享列表 -->
        <ShareList />
      </div>
    </div>
  </van-dialog>
</template>
<script>
  // 分享弹窗
  import ShareImage from './ShareImage'
  import ShareList from './ShareList'
  import MBIcon from '@/components/MBIcon'
  import { mapState, mapGetters } from 'vuex'

  export default {
    components: {
      ShareImage,
      ShareList,
      MBIcon,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      levelCode: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        show: this.value,
      }
    },
    computed: {
      ...mapState(['isApp']),
      ...mapGetters(['displayLayout']),
    },
    watch: {
      value(val) {
        this.show = val
      },
      show(val) {
        this.$emit('input', val)
      },
    },
    methods: {
      close() {
        this.$emit('input', false)
      },
    },
  }
</script>
<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="scss" src="./index_gt.scss"></style>
<style scoped lang="scss" src="./index_pc.scss"></style>
<style lang="scss">
  .share-modal-overlay.van-overlay {
    background-color: rgba(0, 0, 0, 0.9);
  }
</style>
